import React from 'react'
import classnames from 'classnames'

interface ModalMessageIconProps {
  className?: string
}

const ModalMessageIcon: React.FC<ModalMessageIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      className={classnames('icon--modal-message-icon', {
        [className]: !!className,
      })}
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="35" fill="#DDDDDD" fillOpacity="0.6" />
      <path
        d="M49.025 48.712H20.975C19.6977 48.7074 18.4742 48.1979 17.571 47.2948C16.6679 46.3917 16.1585 45.1681 16.1538 43.8909V26.3596C16.1585 25.0823 16.6679 23.8588 17.571 22.9556C18.4742 22.0525 19.6977 21.5431 20.975 21.5385H49.025C50.3023 21.5431 51.5258 22.0525 52.429 22.9556C53.3321 23.8588 53.8415 25.0823 53.8462 26.3596V43.8909C53.8415 45.1681 53.3321 46.3917 52.429 47.2948C51.5258 48.1979 50.3023 48.7074 49.025 48.712ZM20.975 24.1681C20.3938 24.1681 19.8364 24.399 19.4254 24.81C19.0144 25.221 18.7835 25.7784 18.7835 26.3596V43.8909C18.7835 44.4721 19.0144 45.0295 19.4254 45.4404C19.8364 45.8514 20.3938 46.0823 20.975 46.0823H49.025C49.6062 46.0823 50.1636 45.8514 50.5746 45.4404C50.9856 45.0295 51.2165 44.4721 51.2165 43.8909V26.3596C51.2165 25.7784 50.9856 25.221 50.5746 24.81C50.1636 24.399 49.6062 24.1681 49.025 24.1681H20.975Z"
        fill="currentColor"
      />
      <path
        d="M35 37.4919C33.9826 37.4919 32.9838 37.2195 32.1073 36.703L16.8025 27.6043C16.5166 27.4261 16.3087 27.1461 16.2209 26.8208C16.1331 26.4955 16.1718 26.1491 16.3292 25.8511C16.5042 25.5615 16.7855 25.3518 17.113 25.2666C17.4405 25.1814 17.7883 25.2276 18.0823 25.3953L33.4047 34.4765C33.8693 34.76 34.4031 34.9099 34.9474 34.9099C35.4917 34.9099 36.0255 34.76 36.4902 34.4765L51.8125 25.3953C52.1065 25.2276 52.4543 25.1814 52.7818 25.2666C53.1093 25.3518 53.3906 25.5615 53.5657 25.8511C53.723 26.1491 53.7617 26.4955 53.6739 26.8208C53.5861 27.1461 53.3783 27.4261 53.0923 27.6043L37.8927 36.703C37.0162 37.2195 36.0174 37.4919 35 37.4919Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default ModalMessageIcon
